import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { IState } from '../../../../redux/store';
import { urls } from '../../../../config/url';

import httpRequest from '../../../../utils/HttpRequest';
import useActiveModule from '../../../../oldPage/newpage/progress/utils/useActiveModule';
import { stat } from 'fs';
import { useProgressImageShow } from './imageShow';
import ProgressBlock from './ProgressBlock';
import './Cuality.css'

let loadto = 0;

function ProgressImage(props: {
    userName: string, //用户名
    activeProjectName: string, //当前工区
    projectName: string,
    PRO_MODULE_NAME: string
    tabKey: string
}) {

    const [imgPath, setImgPath] = useState({
        filenames: [] as string[],
        qcfilepath: ""
    });

    const [imgs, setImgs] = useState([] as {
        src: string,
        width: number,
        height: number,
    }[]);
    const [show, showJsx] = useProgressImageShow(imgs, imgPath);
    useEffect(() => {
        httpRequest(urls.listQCFile, {
            USER_NAME: props.userName,
            PROJECTNAME: props.activeProjectName,
            proj_name: props.projectName,
            PRO_MODULE_NAME: props.PRO_MODULE_NAME,
            PRO_MODULE_CLASS: "seismic",
            PRO_MODULE_CATEGORY: "ftresonance",
            FLOWTYPE: "fixtime",

        }).then(response => {
            if (response.data.errno === 0) {
                setImgPath(response.data.data);
            } else {
            }
        }).catch(console.log);

    }, [props.projectName,props.tabKey]);
    useEffect(() => {
        loadto = 0;
        for (let oldImg of imgs) {
            URL.revokeObjectURL(oldImg.src);
            setImgs([]);
        }
        if (imgPath.filenames && imgPath.qcfilepath) {
            loadImg(100);
        }
    }, [imgPath]);

    function loadImg(count: number) {
        let imgNew: {
            src: string,
            width: number,
            height: number,
        }[] = ([] as {
            src: string,
            width: number,
            height: number,
        }[]).concat(imgs);
        
        if (imgNew.length !== loadto) {
            return
        }

        const startNo = loadto;
        let endNo = Math.min(imgPath.filenames.length, loadto + count);
        loadto = endNo;



        for (let i = startNo; i < endNo; ++i) {
            httpRequest(urls.getImageBlob, {
                FILEPATH: `${imgPath.qcfilepath}/${imgPath.filenames[i]}`,
            }, { responseType: 'blob' }).then(response => {
                let url = URL.createObjectURL(response.data);
                
                let img = new Image();
                img.src = url;
                img.onload = () => {
                    imgNew = imgNew.concat({
                        src: url,
                        width: img.width,
                        height: img.height,
                    });
                    setImgs(imgNew);
                }
            }).catch(console.log);
        }
    }


    function imgShow() {
        let imgRows: JSX.Element[] = [];

        if (!imgPath.filenames) return imgRows;

        let index = 0;
        let rowIndex = 0;

        function row() {
            let rowImgs = [];

            const width = 1220;
            let height = 250;
            let widthReal = 0;
            let margin = 10;
            let isLastRow = false;

            let realWidth = 150 / imgs[index].height * imgs[index].width;

            while (widthReal + realWidth + 2 * margin < width) {
                widthReal += realWidth + 2 * margin;
                let indexNow = index;
                rowImgs.push(
                    <img
                        src={imgs[index].src}
                        key={index} height={260 + "%"}
                        alt={imgPath.filenames[index]}
                        title={imgPath.filenames[index]}
                        onClick={() => {
                            show(indexNow);
                        }}
                    />

                );
                ++index;
                if (index >= imgs.length) {
                    isLastRow = true;
                    break;
                }
                realWidth = 150 / imgs[index].height * imgs[index].width;
            }
            if (!isLastRow) {
                height = width / widthReal * height;
            }

            return (
                <div key={rowIndex} style={{ height: `${height/2}px` }}>
                    {rowImgs}
                </div>
            )
        }

        while (index < imgs.length) {
            imgRows.push(row());
            ++rowIndex;
        }
        return imgRows;
    }
    useEffect(() => {
        setImgs([])
    },[props.projectName])
    return <>

        <ProgressBlock
            contentsClassName="progress-Image-content"
            className="Image-content"
            title="运行结果图"
            onWheel={e => {
                let height = e.currentTarget.clientHeight;
                let scrollTop = e.currentTarget.scrollTop;
                let scrollHeight = e.currentTarget.scrollHeight;
                let progress = Math.ceil(scrollTop / (scrollHeight - height + 1) * 200);
                if (progress > 70) {
                    loadImg(50);
                }
            }}
        >
            {imgShow()}
        </ProgressBlock>
        <button
            className="progress-image-button"
            onClick={() => {
                httpRequest(urls.downloadDir, {
                    FILEPATH: imgPath.qcfilepath,
                    USER_NAME: props.userName
                }, { responseType: 'blob' }).then(res => {
                    // 得到请求到的数据后，对数据进行处理
                    let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' });// 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
                    let fileName = decodeURI(res.headers['content-disposition']);// 设置文件名称,decodeURI：可以对后端使用encodeURI() 函数编码过的 URI 进行解码。encodeURI() 是后端为了解决中文乱码问题

                    if (fileName) {// 根据后端返回的数据处理文件名称
                        fileName = fileName.substring(fileName.indexOf('=') + 1);
                    }

                    if ('msSaveOrOpenBlob' in navigator) {
                        (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
                        return;
                    }

                    const elink = document.createElement('a')// 创建一个a标签
                    elink.download = fileName;// 设置a标签的下载属性
                    elink.style.display = 'none';// 将a标签设置为隐藏
                    elink.href = URL.createObjectURL(blob);// 把之前处理好的地址赋给a标签的href
                    document.body.appendChild(elink);// 将a标签添加到body中
                    elink.click();// 执行a标签的点击方法
                    URL.revokeObjectURL(elink.href) // 下载完成释放URL 对象
                    document.body.removeChild(elink)// 移除a标签
                }).catch(console.log)
            }}
        >
            图片下载
        </button>
        {showJsx}

    </>
}

const mapStateToProps = (state: {
    user: { userName: string }
    project: { activeName: string },
    progress: any
}) => {

    return {
        userName: state.user.userName, //用户名
        activeProjectName: state.project.activeName, //当前工区
        projectName: state.progress.line.activeName,
        PRO_MODULE_NAME: state.progress.modules.modules[0].PRO_MODULE_NAME

    };
};
export default connect(mapStateToProps)(ProgressImage);